module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Physics_joinedPhysicsEngineComponent__;